import {
  BadgeOutlineMediumIcon,
  BookServicesOutlineMediumIcon,
  ReceiptLongOutlineMediumIcon,
} from '@angeplus/prever-component-lib';

import { CONTRACT } from '../../../routes';

export const PLANS = [
  {
    icon: ReceiptLongOutlineMediumIcon,
    label: 'Pagar boleto (2ª via)',
    uri: CONTRACT,
  },
  {
    icon: BadgeOutlineMediumIcon,
    label: 'Carteirinha',
    uri: CONTRACT,
  },
  {
    icon: ReceiptLongOutlineMediumIcon,
    label: 'Mensalidades',
    uri: CONTRACT,
  },
  {
    icon: BookServicesOutlineMediumIcon,
    label: 'Manual de assistências',
    uri: `${CONTRACT}/assistance-manual`,
  },
];
